<template>
    <div class="flex items-center">
      <div v-show="isHidden">
        <p>
          {{content}}
          <a @click="show" class="text-xxs align-middle cursor-pointer">
            <i aria-hidden="true" class="material-icons align-middle text-sm mx-1">edit</i>
            {{ buttonname }}
          </a>
        </p>
      </div>
      <div v-if="!isHidden" class="w-full" v-click-outside="onClickOutside">
        <div class="flex flex-1 items-center">
          <div class="flex pr-1 w-10/12">
            <input class="w-full" ref="input" type="text"
              :placeholder="content"
              @keydown.enter="putItem"
              v-model="value"
            />
          </div>
          <div class="w-2/12">
            <button type="submit"
              @click="putItem"
              class="commitbutton p-0 inline-block w-10"
              :class="{ 'loading': submitting }"
            ><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i></button>
          </div>
        </div>

        <div v-if="errors.length">
          <p v-for="error in errors"
            class="leading-tight text-red-700 text-xs pb-0 my-3"
          >
            {{ error }}
          </p>
        </div>
      </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import axios from 'axios'

export default {
  props: {
      content: '',
      route:'',
      routeparam:'',
      buttonname: {
        default: 'Change',
      },
  },

  data() {
    return {
      isHidden: true,
      value: this.content,
      submitting: false,
      errors: [],
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  methods: {
    show() {
      this.isHidden = ! this.isHidden;
      this.focusOnField();
    },
    focusOnField() {
      this.$nextTick(() => {
        this.$refs.input?.focus();
      });
    },
    onClickOutside (event) {
        this.isHidden = !this.isHidden
    },
    putItem() {
      if (! this.submitting) {
        this.submitting = true;
        this.errors = [];
        axios.put(this.route, { [this.routeparam]: this.value })
          .then(() => {
            location.reload();
          })
          .catch((errors) => {
            this.submitting = false;
            this.errors = errors.response?.data?.errors?.[this.routeparam] || [];
          })
      };
    }
  },
}
</script>
